/**
 * @typedef {Object} AddOnField
 * @property {string} type - Represents data type of the field
 * @property {any} value - Field value
 * @property {string} field - Field name, used to update form values
 */

const useHandleAddOnFields = () => {
    /**
     * @type {(formValues:any ,addOnFields:AddOnField[]) => formValues:any}
     */
    const handleAddOnFields = (formValues, addOnFields = []) => {
        if (!formValues) throw new Error('formValues is required');
        if (!addOnFields || !addOnFields.length) return formValues;
        const cloneFormValues = { ...formValues };
        addOnFields.forEach((field) => {
            if (!field) return;
            let baseValue = null;
            switch (field.type) {
                case 'string':
                    if (typeof field.value === 'string' && field.value.length > 0) baseValue = field.value;
                    break;
                case 'number':
                    if (typeof field.value === 'number') baseValue = field.value;
                    break;
                case 'boolean':
                    if (typeof field.value === 'boolean') baseValue = field.value;
                    break;
                default:
                    break;
            }
            cloneFormValues[field.field] = baseValue;
        });
        return cloneFormValues;
    };

    return {
        handleAddOnFields,
    };
};

export default useHandleAddOnFields;
